const config = {
  ORIGIN_TYPES: {
    SERVER: 'server',
    CLIENT: 'client',
    0: 'server',
    1: 'client'
  },
  MESSAGE_TYPES: {
    MESSAGE: 'message',
    CHIP: 'chip',
    ATTACHEMENT: 'attachement',
    CAROUSEL_MESSAGE: 'carouselmessage',
    CAROUSEL_ITEM: 'carouselitem',
    CAROUSEL_BUTTON: 'button',
    CAROUSEL_CHIP: 'carouselchip',
    CHIPS: 'chips',
    CAROUSEL_ITEMS: 'carouselItems',
    FORM_MESSAGE: 'formmessage',
    FORM_ITEM: 'formitem',
    FORM_CHIP: 'formchip',
    FORM_ITEMS: 'formitems',
    FORM_CHIPS: 'formchips',
    FORM_TYPE: 'form',
    INPUT_TYPE_TEXTAREA: 'textarea',
    FILE: 'file'
  },
  POPIN_STATUS: {
    OPENED: 'opened',
    CLOSED: 'closed'
  },
  LOCALES: ['fr_FR', 'en_US', 'fr_CA', 'en_GB', 'es_ES', 'zh_HK', 'zh_CN', 'zh_TW', 'pt_PT', 'de_DE', 'it_IT'],
  DEFAULT_LOCALE: 'fr_FR',
  DEV_REGEX_HOST: {
    STAGING: /staging.yelda.ai/,
    LOCALHOST: /localhost*(:[0-9]+)?/
  },
  PROD_REGEX_HOST: {
    WEB_DEMO: /web.yelda.ai/,
    YELDA: /.yelda.ai/ // order matter, keep yelda last
  },
  CANCEL_PAYLOAD: 'cancel',
  SUBMIT_PAYLOAD: 'submit',
  NB_MIN_CAROUSEL: 1,
  MAX_WAITING_TIME: 30000,
  WAITING_TIME: 2000,
  SOCKET_RETRY_DELAY: 1500,
  SOCKET_WELCOME_RETRY_DELAY: 2000,
  NOTIFICATION_INTERVAL: 5000,
  RELOAD_BUTTON_DELAY: 5000,
  SOCKET_EMIT_MAX_TRY: 3,
  VALID_VALIDATORS: ['email', 'numeric'],

  TRIGGER_TYPES: {
    TIME_ON_WEBSITE: 'time_on_website',
    INACTIVITY_DURATION: 'inactivity_duration',
    LEAVE_VIEWPORT: 'leave_viewport'
  },
  PRODUCTION: 'PRODUCTION',
  ENV_CONST: {
    PRODUCTION: {
      NOTIFICATION_WAIT_TIME: 3600,
      PROTOCOL: 'https',
      HOST: 'app.yelda.ai'
    },
    STAGING: {
      NOTIFICATION_WAIT_TIME: 60,
      PROTOCOL: 'https',
      HOST: 'staging.yelda.ai'
    },
    LOCALHOST: {
      NOTIFICATION_WAIT_TIME: 60,
      PROTOCOL: 'http',
      HOST: 'localhost:8080'
    }
  },
  NOTIFICATION_INIT_SECS: 0,
  NOTIFICATION_DATE_FORMAT: 'YYYY/MM/DD',
  PUSH_NOTIFICATION_STATUS: {
    ONLY_FOR_ADMINS: 'only_for_admins'
  },
  INPUT_TYPES: {
    VOICE: 'voice',
    KEYBOARD: 'keyboard',
    TOUCH: 'touch'
  },
  DEVICE_TYPES: {
    MOBILE: 'mobile',
    TABLET: 'tablet',
    DESKTOP: 'desktop'
  },
  SOURCE_TYPES: {
    MENU: 'menu',
    QUICK_REPLY: 'quick_reply'
  },
  TOKEN: 'botTokens',
  MAX_NUMBER_DISPLAYED_QUICK_REPLIES: 5,
  QUICK_REPLY_URL_REGEX: /^(tel|mailto)\:.+$/,
  DEFAULT_OPTIONS_VALUES: {
    IS_AUDIO_RECORDING_VISIBLE: true,
    IS_AUDIO_MOBILE_FRONT: true,
    IS_AUDIO_DESKTOP_FRONT: false,
    IS_FILE_UPLOAD_ACTIVATED: false
  },
  YPARAM_SHOW_BOT: 'yshowbot',
  PLATFORMS_SIMULATED: ['alexa', 'messenger', 'whatsapp'],
  PLATFORM_CSS_BASE_URL: 'https://yelda-chat.s3.eu-west-3.amazonaws.com/css/platforms',
  BOOLEAN_SLOT_TYPE: 'BOOLEAN',
  NB_SESSIONS: 'number_of_sessions',
  REFUSAL_VALUE: 'refusal',
  ASSISTANT_DISPLAY_ID_LENGTH: 5,
  NB_CONVERSATION_THRESHOLD: 1,
  HELPER_TYPES: {
    GEOLOCATION: 'location',
    EXEC_JS_FUNC: 'exec_js_func'
  },
  LOCATION_PERMISSION_TIMEOUT: 10000,
  ERROR_MESSAGE_DELAY: 4000,
  EVENT_TYPES: {
    CLICK: 'click',
    OPEN: 'open',
    CLOSE: 'close'
  },
  EVENT_ELEMENTS: {
    LINK: 'link',
    WEBCHAT_POPIN: 'webchat_popin',
    WEBCHAT_EXEC_JS_FUNC: 'webchat_exec_js_func',
    MENU: 'menu',
    MENU_LINK: 'menu_link'
  },
  DEFAULT_ADMIN_IMAGE: 'https://yelda-chat.s3.eu-west-3.amazonaws.com/images/admin-default-character.png',
  FRAME_EVENT_TYPES: {
    SENT: {
      OPEN_CHAT: 'openChat',
      CLOSE_CHAT: 'closeChat',
      OPEN_URL: 'openUrl',
      LISTEN_LEAVE_VIEWPORT: 'listenLeaveViewport',
      ABSTAIN_LEAVE_VIEWPORT: 'abstainLeaveViewport',
      OPEN_LIGHT_GALLERY: 'openLightGallery',
      LISTEN_URL_UPDATE: 'listenUrlUpdate',
      ABSTAIN_URL_UPDATE: 'abstainUrlUpdate',
      ADD_BUBBLE_TEXT: 'addBubbleText',
      ADD_MINIMAL_NOTIFICATION_TEXT: 'addMinimalNotificationText',
      EXEC_JS_FUNC: 'execJsFunc'
    },
    RECEIVED: {
      OPEN_CHAT: 'openChat',
      SEND_USER_MESSAGE: 'sendUserMessage',
      LEAVE_VIEWPORT: 'leaveViewPort',
      URL_UPDATE: 'urlUpdate'
    }
  },
  USER_ACTIVITY_EVENT_TYPES: ['mousemove', 'mousedown', 'click', 'scroll', 'keypress'],
  NOTIFICATION_STYLES: {
    NORMAL: 'normal',
    MINIMAL: 'minimal'
  },
  EMOJI_S3_URL: 'https://yelda-chat.s3.eu-west-3.amazonaws.com/images/emojis/{imageName}',
  SUBDOMAIN_PART: 'www.',
  TARGET_BLANK: '_blank',
  TARGET_PARENT: '_parent'
}

config.TYPES_GROUP = {
  [config.MESSAGE_TYPES.CHIP]: config.MESSAGE_TYPES.CHIPS,
  [config.MESSAGE_TYPES.CAROUSEL_CHIP]: config.MESSAGE_TYPES.CHIPS,
  [config.MESSAGE_TYPES.CAROUSEL_ITEM]: config.MESSAGE_TYPES.CAROUSEL_ITEMS,
  [config.MESSAGE_TYPES.FORM_ITEM]: config.MESSAGE_TYPES.FORM_ITEMS,
  [config.MESSAGE_TYPES.FORM_CHIP]: config.MESSAGE_TYPES.FORM_CHIPS
}

config.SIMPLE_MESSAGES = [
  config.MESSAGE_TYPES.MESSAGE,
  config.MESSAGE_TYPES.FILE,
  config.MESSAGE_TYPES.CAROUSEL_MESSAGE,
  config.MESSAGE_TYPES.FORM_MESSAGE
]

config.install = function(Vue) {
  Vue.prototype.$getConst = key => {
    return key.split('.').reduce((obj, index) => obj[index], config)
  }
}

export default config
